/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';
import EmptyArray from 'lib/EmptyArray';
import useGoogleButtons from '../useGoogleButtons';
import underscored from 'underscore.string/underscored';
import getFilledUrl from '../Integration/getFilledUrl';
import log from 'lib/log';

type PropsT = {
  resource: { [key: string]: { [key: string]: any } },
  resourceName: string,
};

export default ({ resource, resourceName }: PropsT): null | Element<string> => {
  const { data, error, loading } = useGoogleButtons();

  if (error) {
    log.error(error.message);
    const msg =
      'Error loading Google Form buttons. Please refresh this page to see your buttons.';
    return <div className="text-danger">{msg}</div>;
  }
  if (loading) return <i className="fa fa-spinner fa-spin" />;

  // Filter buttons by the resource.
  const googleButtons = data.filter(
    (v) =>
      underscored(v.resourceName) === resourceName ||
      resourceName === v.resourceName
  );
  if (EmptyArray.is(googleButtons)) return null;

  const valueMap =
    resource[resourceName] || resource[underscored(resourceName)];

  return (
    <div data-testid="GoogleButtonRow" className="mt-3 mb-2">
      {googleButtons.map((config, i) => {
        const url = valueMap && getFilledUrl(config, valueMap);
        return (
          <a
            key={i}
            href={url}
            disabled={!url}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={0}
            className="btn btn-lg btn-primary mr-1"
            data-testid={`GoogleButtonRow-${config.id}`}
          >
            {config.name}{' '}
          </a>
        );
      })}
    </div>
  );
};
